@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';

.shopper-collection {
  margin-top: @space-12;
}

.loading-indicator {
  height: 64px;
  width: 64px;
  margin: 40px auto;
}
